import { CSSProperties, useMemo } from 'react';
import { WindowGeometry } from '../../../windows/types';
import useResizers, { ResizersProps } from './useResizers';
import {
  BottomLeftLine,
  BottomLine,
  BottomRightLine,
  LeftLine,
  RightLine,
  TopLeftLine,
  TopLine,
  TopRightLine,
} from './Lines';

const Resizers: React.FC<ResizersProps> = (props) => {
  const onMouseDown = useResizers(props);

  const allResizers = useMemo(
    () => (
      <>
        <TopLine onMouseDown={onMouseDown} />
        <RightLine onMouseDown={onMouseDown} />
        <BottomLine onMouseDown={onMouseDown} />
        <LeftLine onMouseDown={onMouseDown} />
        <TopLeftLine onMouseDown={onMouseDown} />
        <TopRightLine onMouseDown={onMouseDown} />
        <BottomLeftLine onMouseDown={onMouseDown} />
        <BottomRightLine onMouseDown={onMouseDown} />
      </>
    ),
    [onMouseDown]
  );

  return (
    <div
      style={{
        pointerEvents: props.disabled ? 'none' : 'all',
      }}
    >
      {allResizers}
    </div>
  );
};

const styles = {
  container: (geometry: WindowGeometry) =>
    ({
      // position: 'absolute',
      // top: `${0}px`,
      // left: `${0}px`,
      // width: '100%',
      // height: '100%'
      // top: `${geometry.y}px`,
      // left: `${geometry.x}px`,
      // width: `${geometry.width}px`,
      // height: `${geometry.height}px`,
    } as CSSProperties),
};

export default Resizers;
